import { render, staticRenderFns } from "./OutstandingTasks.vue?vue&type=template&id=8c1fdc82&scoped=true&"
import script from "./OutstandingTasks.vue?vue&type=script&lang=js&"
export * from "./OutstandingTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c1fdc82",
  null
  
)

export default component.exports